import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgAppIcDocumentNew24 = (props) => /* @__PURE__ */ _jsx("svg", {
	id: "New_Document",
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	style: { fill: "currentColor" },
	...props,
	children: /* @__PURE__ */ _jsx("g", {
		id: "Form",
		children: /* @__PURE__ */ _jsx("path", { d: "m15,13h-2v-2c0-.55-.45-1-1-1s-1,.45-1,1v2h-2c-.55,0-1,.45-1,1s.45,1,1,1h2v2c0,.55.45,1,1,1s1-.45,1-1v-2h2c.55,0,1-.45,1-1s-.45-1-1-1Zm-1-11c.28,0,.53.09.72.31h0l4,4c.19.19.28.41.28.69h0v14c0,.56-.44,1-1,1H6c-.56,0-1-.44-1-1h0V3c0-.56.44-1,1-1h8Zm-2,2h-5v16h10v-11h-4c-.56,0-1-.47-1-1h0V4Zm2,.41v2.59h2.59l-2.59-2.59Z" })
	})
});
export default SvgAppIcDocumentNew24;
